// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2LUHR","signatureButtonsRight":"ModalSign_signatureButtonsRight__1axs2"};